export default "__VITE_ASSET__Y5iNmYqO__"